// ============================================
// LOGFUSIONES.JS — Tabla de fusiones realizadas (vista admin)
// ============================================

import React, { useEffect, useState } from 'react';
import {
  API_BASE_CLI, PP, COLOR_PRINCIPAL, COLOR_OSCURO, COLOR_FONDO, COLOR_GRIS,
  COLOR_GRIS_CLARO, COLOR_BORDE,
  estiloBotonSecundario, estiloTarjeta, CabeceraFicha,
} from './helpersClientes';
import { authHeaders } from '../utils/storage';

const TIPOS = [
  { id: '',            label: 'Todos' },
  { id: 'grupo',       label: 'Grupos (clientes)' },
  { id: 'razon_social', label: 'Razones sociales' },
  { id: 'persona',     label: 'Personas' },
  { id: 'conversion_sucursal', label: 'Conversiones a sucursal' },
];

export default function LogFusiones({ onVolver, esCelular }) {
  const [tipo, setTipo] = useState('');
  const [fusiones, setFusiones] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [expandida, setExpandida] = useState(null);

  const cargar = async () => {
    setCargando(true);
    try {
      const params = new URLSearchParams();
      if (tipo) params.set('entidad_tipo', tipo);
      const r = await fetch(`${API_BASE_CLI}/api/clientes/fusiones-log?${params}`, { headers: authHeaders() }).then(x => x.json());
      setFusiones(r.fusiones || []);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargar(); }, [tipo]);

  return (
    <div style={{ fontFamily: PP, background: COLOR_FONDO, minHeight: '100%', color: COLOR_GRIS }}>
      <CabeceraFicha
        volver={onVolver}
        titulo="⚙️ Historial de fusiones"
        subtitulo={`${fusiones.length} fusión${fusiones.length === 1 ? '' : 'es'} registrada${fusiones.length === 1 ? '' : 's'}`}
      />
      <div style={{ padding: esCelular ? 12 : '20px 28px', display: 'grid', gap: 12 }}>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {TIPOS.map(t => (
            <button
              key={t.id || 'todos'}
              onClick={() => setTipo(t.id)}
              style={{
                padding: '6px 14px', borderRadius: 99, border: 'none',
                background: tipo === t.id ? COLOR_PRINCIPAL : '#fff',
                color: tipo === t.id ? '#fff' : COLOR_GRIS,
                fontSize: 12, fontWeight: tipo === t.id ? 600 : 500,
                cursor: 'pointer', fontFamily: PP,
              }}
            >{t.label}</button>
          ))}
        </div>

        {cargando && <div style={{ textAlign: 'center', padding: 40, color: COLOR_GRIS_CLARO }}>Cargando…</div>}
        {!cargando && fusiones.length === 0 && (
          <div style={{ textAlign: 'center', padding: 60, color: COLOR_GRIS_CLARO, fontSize: 13 }}>
            No hay fusiones registradas.
          </div>
        )}

        {fusiones.map(f => (
          <div key={f.id} style={estiloTarjeta}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO }}>
                  {new Date(f.creado_en).toLocaleString('es-MX')} · {etiquetaTipo(f.entidad_tipo)}
                </div>
                <div style={{ fontSize: 13, fontWeight: 600, color: COLOR_OSCURO, marginTop: 4 }}>
                  <span>Conservada: {f.conservada_nombre || `#${f.entidad_conservada_id}`}</span>
                </div>
                <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, marginTop: 2 }}>
                  Absorbida: {f.absorbida_nombre || `#${f.entidad_absorbida_id}`} (archivada)
                </div>
                {f.motivo && <div style={{ fontSize: 11, color: COLOR_GRIS_CLARO, marginTop: 4, fontStyle: 'italic' }}>"{f.motivo}"</div>}
              </div>
              <button
                style={estiloBotonSecundario}
                onClick={() => setExpandida(expandida === f.id ? null : f.id)}
              >
                {expandida === f.id ? 'Ocultar' : 'Ver detalles'}
              </button>
            </div>
            {expandida === f.id && (
              <div style={{ marginTop: 14, paddingTop: 14, borderTop: `1px solid ${COLOR_BORDE}` }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: COLOR_OSCURO, marginBottom: 6 }}>Registros transferidos:</div>
                <pre style={preStyle}>{JSON.stringify(f.registros_transferidos, null, 2)}</pre>
                <div style={{ fontSize: 12, fontWeight: 700, color: COLOR_OSCURO, marginTop: 10, marginBottom: 6 }}>Snapshot conservada:</div>
                <pre style={preStyle}>{JSON.stringify(f.datos_conservados, null, 2)}</pre>
                <div style={{ fontSize: 12, fontWeight: 700, color: COLOR_OSCURO, marginTop: 10, marginBottom: 6 }}>Snapshot absorbida:</div>
                <pre style={preStyle}>{JSON.stringify(f.datos_absorbidos, null, 2)}</pre>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const preStyle = {
  background: '#f3f4f4', padding: 10, borderRadius: 6, fontSize: 10,
  fontFamily: 'monospace', maxHeight: 200, overflow: 'auto',
  whiteSpace: 'pre-wrap', wordBreak: 'break-word',
};

function etiquetaTipo(t) {
  return {
    grupo: 'Grupo (cliente)', razon_social: 'Razón social', persona: 'Persona',
    conversion_sucursal: 'Conversión a sucursal',
  }[t] || t;
}
